module.exports = {
  src: __webpack_public_path__ + "logo-appstore-4c81e988ed84d403ceb14c37ce8775ea.svg",
  width: 135,
  height: 40,
  bytes: 6371,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-appstore-4c81e988ed84d403ceb14c37ce8775ea.svg";
};